import React from "react";
import { Typography, Container, Paper, Box } from "@mui/material";

export default function EducationPage() {
  return (
    <Container maxWidth="lg">
      <Paper sx={{ padding: 4, marginTop: 4 }}>
        <Typography variant="h4" gutterBottom>Education</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Finance glossary, metric definitions, how to read statements
        </Typography>
        <Box>
          <Typography variant="subtitle1" color="text.secondary">
            [Demo charts or tables would appear here based on GCS long-format financial data.]
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}